import { render, staticRenderFns } from "./DisplayAmountObj.vue?vue&type=template&id=042dc4b0&scoped=true&"
import script from "./DisplayAmountObj.vue?vue&type=script&lang=js&"
export * from "./DisplayAmountObj.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAmountObj.vue?vue&type=style&index=0&id=042dc4b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042dc4b0",
  null
  
)

export default component.exports